// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2R8EM","label":"SetPasswdForm_label__20Q3O"};